<span
  #iconEl
  [ngClass]="classNames"
  role="img"
  [attr.aria-label]="ariaLabel"
  [attr.aria-labelledby]="ariaLabelledby"
  [attr.aria-hidden]="!ariaLabel && !ariaLabelledby"
  class="bb-icon"
></span>
